import {HTHSymbol, HTHSymbolStates, ISymbolData} from "./HTHSymbol";
import {HTH} from "../HTH";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";
import {gsap} from "gsap";
import {HTHGameAssets} from "../HTHGameAssets";
import {HTHXNudgeSymbol} from "./HTHXNudgeSymbol";
import {HTHHelper} from "../utils/HTHHelper";
import {HTHXWaysSymbol} from "./HTHXWaysSymbol";
import {HTHXSplitSymbol} from "./HTHXSplitSymbol";
import {HTHWildSymbol} from "./HTHWildSymbol";
import {HTHRemovalSymbol} from "./HTHRemovalSymbol";
import {HTHNormalSymbol} from "./HTHNormalSymbol";
import {HTHBlankSymbol} from "./HTHBlankSymbol";
import {HTHXNudgePresentation} from "../presentations/HTHXNudgePresentation";

export class HTHSafeSymbol extends HTHSymbol {

    private _isFilled: boolean;//false-empty , true-carrying other symbol
    private _revealedSymbolContainer: PIXI.Container;
    private _spineContainer: PIXI.Container;
    private _frameContainer: PIXI.Container;
    private _safeMultiplier: PIXI.BitmapText;
    private _revealSym: HTHSymbol | null;
    // private _currentSpine: PIXI.spine.Spine | null;
    private _ssSpine: PIXI.spine.Spine;
    private _saSpine: PIXI.spine.Spine;
    private _upperContainer: PIXI.Container;
    private _lowerContainer: PIXI.Container;

    constructor(symbolData: ISymbolData, state: HTHSymbolStates) {
        super(symbolData);
        state = HTHSymbolStates.NO_WIN;
        this._isFilled = false;
        this._revealSym = null;
        this._revealedSymName = "";
        this._participatedInWin = false;
        this._isAnticipationPlaying = false;
        this._safeSymSize = symbolData.symSize === 1 ? 0 : symbolData.symSize;
        this.symSize = this._safeSymSize;

        this._frameContainer = new PIXI.Container();
        this._frameContainer.name = "frameContainer";

        this._spineContainer = new PIXI.Container();
        this._spineContainer.name = "spineContainer";

        this._revealedSymbolContainer = new PIXI.Container();
        this._revealedSymbolContainer.name = "revealedsymbolContainer";

        this._upperContainer = new PIXI.Container();
        this._upperContainer.name = "upperContainer";
        this._lowerContainer = new PIXI.Container();
        this._lowerContainer.name = "lowerContainer";
        // this._ssSprite=new PIXI.Sprite(HTH.assetLoader.getTextures("S_SC/S_SC")[0]);
        // this._ssSprite.anchor.set(0.5, 0.5);

        this._ssSpine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("SS"));
        this._ssSpine.state.setAnimation(0, "idle", false);

        this._saSpine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("SA"));
        this._saSpine.state.setAnimation(0, "normal", false);


        this.addChild(this._revealedSymbolContainer, this._lowerContainer, this._spineContainer, this._frameContainer);

        this.addSpineAnimation(state);
        //this.symbolAnimChange("normal");
        this.addSymbolMultiplier();

    }

    private _revealedSymName: string;

    public get revealedSymName(): string {
        return this._revealedSymName;
    }

    public set revealedSymName(setValue: string) {
        this._revealedSymName = setValue;
    }

    private _safeSymSize: number;

    // private _ssSprite:PIXI.Sprite;

    public get safeSymSize(): number {
        return this._safeSymSize;
    }

    public set safeSymSize(setValue: number) {
        this._safeSymSize = setValue;
    }

    private _isCollected: boolean = false;

    public get isCollected(): boolean {
        return this._isCollected;
    }

    public set isCollected(value: boolean) {
        this._isCollected = value;
    }

    private _participatedInWin: boolean;

    get participatedInWin(): boolean {
        return this._participatedInWin;
    }

    set participatedInWin(value: boolean) {
        this._participatedInWin = value;
    }

    private _isAnticipationPlaying: boolean;

    get isAnticipationPlaying(): boolean {
        return this._isAnticipationPlaying;
    }

    set isAnticipationPlaying(value: boolean) {
        this._isAnticipationPlaying = value;
    }

    public get isSafeFilled(): boolean {
        return this._isFilled;
    }

    public set isSafeFilled(setValue: boolean) {
        this._isFilled = setValue;
    }

    public get revealedSymbol(): HTHSymbol | null {
        return this._revealSym;
    }

    public set revealedSymbol(value: HTHSymbol | null) {
        this._revealSym = value;
    }

    public unlockSymbol() {
        if (!this._isFilled) {
            this.symSize = 1;
            //this.addImage("SA_empty");
            const thisSprite: PIXI.Sprite = <PIXI.Sprite>this.getChildByName("currentStateSprite");
            const safeFrame: PIXI.Sprite = new PIXI.Sprite(HTH.assetLoader.getTextures("SA_frame")[0]);
            safeFrame.anchor.set(0.5, 0.5);
            safeFrame.position.set(0, 0);
            thisSprite.addChild(safeFrame);
        }
    }

    public emptySafe(): void {
        this._revealedSymName = "";
        this._revealSym = null;
    }

    public changeSpine(spineName: string, toChange: boolean): void {
        // this._spineContainer.removeChild(this._currentSpine!);
        // this._currentSpine = null;
        this._saSpine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("SA"));//`${spineName}`
        // this._currentSpine.visible = true;
        this._saSpine.name = "safeSpine";
        // this._currentSpine.position.set(0, 0);

        // console.log("currentSpine",this._currentSpine);
        // if (spineName === "SA") {
        //     HTHHelper.playSpineWithTimeline(this._currentSpine,0,"open_blank").reverse(1,false).pause(0.001,false);
        //       // this._currentSpine.state.setAnimation(0, "normal", false);
        // }

        // if (spineName === "SA") {
        this._saSpine.state.setAnimation(0, "open_blank", false);
        this._ssSpine.visible = false;
        // }
        this._spineContainer.addChild(this._saSpine, this._upperContainer, this._safeMultiplier);


        // if(( HTH.model.data.mode.includes("NORMAL"))  && !toChange){
        //     this._spineContainer.addChild(this._ssSpine);
        // }
        // if(toChange){
        //     this._ssSpine.visible=false;
        // }

    }

    public symbolAnimChange(animName: string): gsap.core.Timeline {
        //  HTHHelper.resetSpineItem(this._currentSpine!); #todo check why again this resetting spine causes glitches
        if (animName === "open_emptyBox") {
            this.addChild(this._spineContainer);
        }
        return HTHHelper.playSpineWithTimeline(this._saSpine!, 0, `${animName}`);
    }

    public ssSymbolAnimChange(animName: string, includeInTl: boolean, toLoop: boolean, speed: number = 1): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();

        if (includeInTl) {
            tl.add(HTHHelper.playSpineWithTimeline(this._ssSpine, 0, animName));
        } else {
            if (animName === "anticipation") {
                this._isAnticipationPlaying = true;
            }
            tl.add(() => {
                this._ssSpine!.autoUpdate = true;
                this._ssSpine.state.setAnimation(0, animName, toLoop).timeScale = speed;
            });
        }

        return tl;
    }

    public revealedSymbolAnimChange(animName: string): gsap.core.Timeline {
        const playAnimTl: gsap.core.Timeline = gsap.timeline();
        playAnimTl.add(this._revealSym!.animationChange(animName));
        return playAnimTl;
    }

    public revealAnotherSymbol(symName: string, symSize: number): gsap.core.Timeline {
        this.emptyRevealContainer();
        if (this._revealedSymbolContainer.children.length === 0) {
            if (symName !== "SA") { //meaning new safe symbol ,so currently empty
                this.revealSymbol(symName, symSize);
                this.addChild(this._spineContainer);
            }
        }
        return gsap.timeline().to(this, {duration: 0.01});
    }

    public revealSymbol(revealSymName: string, revealSymSize: number, revealingWild: boolean = false) {
        this.emptyRevealContainer();
        this._participatedInWin = false;
        let revealSym: HTHSymbol;
        const revealSymData: ISymbolData = {
            symName: revealSymName,
            symSize: revealSymName === "XN" ? revealSymSize : 1,
            id: this.id,
            reelId: this.reelId,
            spinPosition: 0
        }

        if (revealSymName === "XW") {
            revealSym = new HTHXWaysSymbol(revealSymData, HTHSymbolStates.NORMAL);
        } else if (revealSymName === "XS") {
            revealSym = new HTHXSplitSymbol(revealSymData, HTHSymbolStates.NORMAL);
        } else if (revealSymName === "XN") {
            revealSym = new HTHXNudgeSymbol(revealSymData, HTHSymbolStates.NORMAL);
        } else if (revealSymName === "W") {
            revealSym = new HTHWildSymbol(revealSymData, HTHSymbolStates.NORMAL);
        } else if (revealSymName === "RW") {
            revealSym = new HTHRemovalSymbol(revealSymData, HTHSymbolStates.NORMAL);
        } else if (revealSymName === "BL") {
            revealSym = new HTHBlankSymbol(revealSymData, HTHSymbolStates.BLANK);
        } else {
            revealSym = new HTHNormalSymbol(revealSymData, HTHSymbolStates.NORMAL);
        }
        this.handleMultiplierVisibility(1);

        this._revealedSymbolContainer.addChild(revealSym);
        if (revealSym.symName === "W" && revealingWild) {
            this._upperContainer.addChild((<HTHWildSymbol>revealSym).spine);
        }
        // this.addChild(this._revealedSymbolContainer);
        this._revealedSymName = revealSymName;
        this._revealSym = revealSym;

    }

    public updatexNudgeMultiplierForRestore(isRestore: boolean) {
        return (<HTHXNudgeSymbol>this._revealedSymbolContainer.children[0]).updatexNudgeMultiplierForRestore(isRestore);
    }

    public revealXNudgeSize(symNudgedOverId: number, symNudgedOverSymSize: number): gsap.core.Timeline {
        return (<HTHXNudgeSymbol>this._upperContainer.children[0]).revealXNudgeSize(symNudgedOverId, symNudgedOverSymSize);
    }

    public playXNudgeAnim(XNSymId: number, isEnhancerOpen: boolean, isRestore: boolean = false): gsap.core.Timeline {
        return (<HTHXNudgeSymbol>this._upperContainer.children[0]).playXNudgeAnim(XNSymId, isEnhancerOpen, isRestore);
    }

    public playXNudgeAnimForRestore(XNSymId: number, isEnhancerOpen: boolean, isRestore: boolean = false): gsap.core.Timeline {
        return (<HTHXNudgeSymbol>this._revealedSymbolContainer.children[0]).playXNudgeAnim(XNSymId, isEnhancerOpen, isRestore);
    }

    public playBikerAnim(XNSymId: number, isEnhancerOpen: boolean): gsap.core.Timeline {
        return (<HTHXNudgeSymbol>this._upperContainer.children[0]).playBikerAnim(XNSymId, isEnhancerOpen);
    }

    public addXNudgeRevealSym(sym: HTHSymbol) {
        this._revealedSymbolContainer.addChild(sym);
    }

    public emptyRevealContainer(): void {
        if (this._revealedSymbolContainer.children.length > 0) {
            this._revealedSymbolContainer.children.forEach((item) => {
                item.destroy();
            })
            this._revealedSymbolContainer.removeChildren();
            this._revealSym = null;
            this.revealedSymName = "";
        }
        if (this._upperContainer.children.length > 0) {
            this._revealedSymbolContainer.children.forEach((item) => {
                item.destroy();
            })
            this._upperContainer.removeChildAt(0);
            this._revealSym = null;
            this.revealedSymName = "";
        }
    }

    public removalExplode(): gsap.core.Timeline {
        const remExTL: gsap.core.Timeline = gsap.timeline();
        remExTL.to(this, {duration: 0.25});

        remExTL.add(() => {
            this.isSafeFilled = false;
            this.emptyRevealContainer();
            this.symbolAnimChange("empty");
        }, ">");
        return remExTL;
    }

    public showWaysIncrease(toAdd: number): gsap.core.Timeline {
        const waysTl: gsap.core.Timeline = gsap.timeline();
        for (let i: number = 0; i < toAdd; i++) {
            const incrementTl: gsap.core.Timeline = gsap.timeline();
            incrementTl.add(() => {
                this.safeSymSize += 1;
                this.symSize = this.safeSymSize
                if (this.safeSymSize >= 1) {
                    this._safeMultiplier.visible = true;
                    this._spineContainer.addChild(this._upperContainer, this._safeMultiplier);
                }
                this._safeMultiplier.text = "x" + this._safeSymSize;
                this.adjustMultiWidth();
            }, 0);
            incrementTl.to(this, {duration: 0.07});
            waysTl.add(incrementTl);
        }
        return waysTl;
    }

    public highlight(): gsap.core.Timeline {
        const highlightTl: gsap.core.Timeline = gsap.timeline();
        const winHighlightAnim: TimelineSprite = this.getWinHighlightAnim();
        if (this.revealedSymbol?.symName !== "BL") {
            highlightTl.add(() => {
                this.movetoParticularMaskedLayer(HTH.reelArea.allReels[this.reelId].reelView.reelLayers.winLayer);
            }, 0);
        }
        if (this.revealedSymbol?.name === "XN") {
            highlightTl.add(() => {
                (<HTHXNudgeSymbol>this.revealedSymbol).highlight();
                (<HTHXNudgeSymbol>this.revealedSymbol).movetoParticularMaskedLayer(HTH.reelArea.allReels[this.reelId].reelView.reelLayers.winLayer);
            }, 0);
        }
        highlightTl.add(<gsap.core.Timeline><unknown>winHighlightAnim.getAnimationAutoShowHide());
        highlightTl.add(() => {
            winHighlightAnim.destroy();
        });

        return highlightTl;
    }

    public explode(): gsap.core.Timeline {
        let explodeTl: gsap.core.Timeline = gsap.timeline();
        const spine: PIXI.spine.Spine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("blast"));
        if (this.revealedSymbol?.name === "XN") {
            explodeTl.add(() => {
                (<HTHXNudgeSymbol>this.revealedSymbol).explode();
                this.revealedSymName = "";
            }, 0);
        }
        explodeTl.add(() => {
            this.addChild(spine);
        });

        explodeTl.add(HTHHelper.playSpineWithTimeline(spine, 0, "blast"));

        if (this._revealedSymName !== "RW") {
            if (this._revealedSymbolContainer.children.length > 0) {
                explodeTl.to(this._revealedSymbolContainer.children[0], {
                    alpha: 0,
                    duration: 0.533
                }, "<");
            }
            if (this._upperContainer.children.length > 0) {
                explodeTl.to(this._upperContainer.children[0], {
                    alpha: 0,
                    duration: 0.533
                }, "<");
            }
        }
        explodeTl.add(() => {
            this.isSafeFilled = false;
            this.symbolAnimChange("empty");
        }, "<");
        explodeTl.add(() => {
            spine.destroy();
            if (this._revealedSymName !== "RW") {
                this.emptyRevealContainer();
            }
            this.symbolAnimChange("close_emptyBox");
            this.movetoParticularMaskedLayer(HTH.reelArea.allReels[this.reelId].reelView.reelLayers.safeLayer);
            // this.switchLayers(true);
        })
        return explodeTl;
    }

    public addSymbolMultiplier() {
        if (this._safeMultiplier) {
            this.removeSymbolMultiplier();
        }
        const textStyle: PIXI.TextStyle = new PIXI.TextStyle({
            "dropShadow": true,
            "dropShadowAlpha": 0.6,
            "dropShadowBlur": 3,
            "dropShadowDistance": 0,
            "fill": "#ffffff",
            "fontSize": 30,
            "fontWeight": "bold",
            "letterSpacing": 1,
            "stroke": "#b30000",
            "strokeThickness": 3
        });


        this._safeMultiplier = new PIXI.BitmapText("", {
            fontName: HTHGameAssets.BITMAP_FONT_SYMBOL_SIZE_MULTIPLIER,
            fontSize: 11,
            letterSpacing: -35,
        });
        this._safeMultiplier.name = "safe Total Multiplier";
        this._spineContainer.addChild(this._upperContainer, this._safeMultiplier);
        this._safeMultiplier.anchor = new PIXI.Point(0.5, 0);
        this.adjustMultiWidth();
        this.updateSymbolMultiplier(this.safeSymSize);
    }

    public updateSymbolMultiplier(value: number): void {
        this._safeMultiplier.visible = this.safeSymSize > 1;
        this._safeMultiplier.text = `x${value}`;
        this.adjustMultiWidth();
        // this._safeMultiplier.width = 30;
    }

    public removeSymbolMultiplier() {
        this._revealedSymbolContainer.removeChild(this._safeMultiplier);
        this._safeMultiplier.destroy();
    }

    public resetSpine(): void {
        HTHHelper.resetSpineItem(this._saSpine!);
    }

    public addSplitEffect(size: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        this.safeSymSize = this.safeSymSize === 0 ? 2 : this.safeSymSize * 2;
        this.symSize = this.safeSymSize;
        tl.add(this.splitMultiplier(size === 0 ? 2 : size * 2));
        // this.updateSymbolMultiplier(this.safeSymSize);
        return tl;
    }

    public splitMultiplier(size: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        let orangeMulti: PIXI.BitmapText = new PIXI.BitmapText("", {
            fontName: HTHGameAssets.BITMAP_FONT_SYMBOL_SIZE_MULTIPLIER,
            fontSize: 11,
            tint: 0xFFA500,
            letterSpacing: -35,
        });
        let scale: number = JSON.parse(JSON.stringify(this._safeMultiplier.scale.x));

        tl.add(() => {
            this._safeMultiplier.addChild(orangeMulti);
            this._safeMultiplier.alpha = 1;
            orangeMulti.anchor = new PIXI.Point(0.5, 0);
            orangeMulti.alpha = 0;
            orangeMulti.text = this._safeMultiplier.text;
            this.adjustMultiWidth();
        }, 0)

        if (this.symSize > 1) {
            tl.to(this._safeMultiplier.scale, {x: scale - 0.1, y: scale - 0.1, duration: 0.333});
            tl.to(this._safeMultiplier.scale, {x: scale + 0.4, y: scale + 0.4, duration: 0.033});
            tl.add(() => {
                this._safeMultiplier.text = `x${size}`;
                orangeMulti.text = this._safeMultiplier.text;
                this._safeMultiplier.visible = true;
                this._safeMultiplier.anchor = new PIXI.Point(0.5, 0);
                this.adjustMultiWidth();
                this._safeMultiplier.maxWidth = 25;
            }, ">");
            tl.to(orangeMulti, {alpha: 1, duration: 0.001});
            tl.to(orangeMulti, {alpha: 0, duration: 0.165});

            tl.to([this._safeMultiplier.scale], {x: scale - 0.1, y: scale - 0.1, duration: 0.132}, "<")
            tl.to([this._safeMultiplier.scale], {x: scale, y: scale, duration: 0.033});
            tl.add(() => {
                this.adjustMultiWidth();
                this.removeChild(orangeMulti);
                orangeMulti.destroy();
            }, ">");

        }
        return tl;
    }

    public convertEffects(): gsap.core.Timeline {
        const effectTl: gsap.core.Timeline = gsap.timeline();
        let effectSeq: TimelineSprite = new TimelineSprite((HTH.assetLoader.getTextures("superScatterConvertEffect")));
        effectSeq.position.set(0, 0);
        effectSeq.anchor.set(0.5, 0.5);
        effectSeq.blendMode = PIXI.BLEND_MODES.ADD;
        effectSeq.name = "fssafeeffect";
        effectSeq.visible = false;
        this._frameContainer.addChild(effectSeq);
        //console.log(effectSeq.totalDuration); //0.833
        effectTl.add(<gsap.core.Timeline><unknown>effectSeq.getAnimationAutoShowHide());
        effectTl.add(() => {
            this._frameContainer.removeChild(effectSeq);
            effectSeq.destroy();
        })
        return effectTl;
    }

    public handleMultiplierVisibility(alpha: number): void {
        this._safeMultiplier.alpha = alpha;
    }

    public handleSpineVisibility(alpha: number): void {
        this._spineContainer.alpha = alpha;
    }

    public removeAndDestroy(): void {
        if (this._safeMultiplier) {
            this.removeSymbolMultiplier();
        }
        if (this.parent) {
            this.parent.removeChild(this);
        }
        this.destroy({children: true});
        this.isRemoved = true;
    }

    public setInteractive(val: boolean): void {
        if (val && this._isFilled && this.revealedSymbol) {
            if (this.revealedSymName.includes("M") && this.revealedSymName !== "MAX" || this.revealedSymName.includes("L"))
                (<HTHNormalSymbol>this.revealedSymbol).setInteractive(val);
        }
    }

    public addBgForSpecialSymbol(sprite: PIXI.spine.Spine, spine: PIXI.spine.Spine) {
        this._lowerContainer.addChild(sprite);
        this._upperContainer.addChild(spine);
    }

    public removeBgForSpecialSymbol(sprite: PIXI.spine.Spine, spine: PIXI.spine.Spine): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        if (this._lowerContainer.children.includes(sprite)) {
            tl.add(() => {
                this._lowerContainer.removeChild(sprite);
            }, 0);
        }
        if (this._upperContainer.children.includes(spine)) {
            tl.add(() => {
                this._upperContainer.removeChild(spine);
            }, 0);
        }

        return tl;

    }

    public popOutSpecialsymbol(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        if (this._revealedSymbolContainer.children.length > 0) {
            const spine: PIXI.spine.Spine = (<HTHXWaysSymbol | HTHXSplitSymbol | HTHRemovalSymbol | HTHWildSymbol>this._revealedSymbolContainer.children[0]).spine;
            tl.to(spine.scale, {x: 0.8, y: 0.8, duration: 0.02});
            tl.add(() => {
                this._upperContainer.addChild(spine);
            }, ">");
            tl.to(spine.scale, {x: 1, y: 1, duration: 0.08});
        }

        return tl;
    }

    public popOutXN(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        if (this._revealedSymbolContainer.children.length > 0) {
            const symbol: HTHXNudgeSymbol = <HTHXNudgeSymbol>this._revealedSymbolContainer.children[0];
            tl.to(symbol.scale, {x: 0.8, y: 0.8, duration: 0.02});
            tl.add(() => {
                this._upperContainer.addChild(symbol);
            }, ">");
            tl.to(symbol.scale, {x: 1, y: 1, duration: 0.08});
        }
        return tl;
    }

    public popInSpecialsymbol(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        if (this._upperContainer.children.length > 0) {
            const spine: PIXI.spine.Spine = <PIXI.spine.Spine>this._upperContainer.children[0];

            tl.to(spine.scale, {x: 0.8, y: 0.8, duration: 0.1});
            tl.add(() => {
                this._revealedSymbolContainer.addChild(spine);
            }, ">");
            tl.to(spine.scale, {x: 1, y: 1, duration: 0.1});
        }
        return tl;
    }

    public playMultiPumpAnim(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        const scale: number = JSON.parse(JSON.stringify(this._safeMultiplier.scale.x));
        tl.to(this._safeMultiplier.scale, {x: scale + 0.2, y: scale + 0.2, duration: 0.3});
        tl.to(this._safeMultiplier.scale, {x: scale, y: scale, duration: 0.3});
        return tl;
    }

    public resetMultiSize(): void {
        this._safeMultiplier.scale.set(1, 1);
        this.adjustMultiWidth();
    }

    private addSpineAnimation(state: HTHSymbolStates = HTHSymbolStates.NORMAL, duration: number = 0): gsap.core.Timeline {
        if (this.symbolState === state) {
            return gsap.timeline();
        }

        if (HTH.model.mode.includes("NORMAL")) {
            this._spineContainer.addChild(this._ssSpine, this._upperContainer);
        } else {
            this._spineContainer.addChild(this._saSpine, this._upperContainer);
        }

        // this.changeSpine(HTH.model.isFreespin || (HTH.model.mode===HTHGameMode.EXTRA_SPIN && HTH.model.nextMode===HTHGameMode.FREESPIN) ? "SA" : "SS",false);
        this.symbolState = state;
        return gsap.timeline();
    }

    private adjustMultiWidth(): void {
        const prevScale: number = this._safeMultiplier.scale.x;
        if (this._safeMultiplier.width > 100) {
            const scale = 100 / this._safeMultiplier.width;
            this._safeMultiplier.scale.set(scale * prevScale);
        }
        this._safeMultiplier.pivot.set(0, this._safeMultiplier.height / this._safeMultiplier.scale.x);
        this._safeMultiplier.position.set(0, this._saSpine.height / 2 - 7);
    }


}
